
import {BsLinkedin} from 'react-icons/bs'
import {BsGithub} from 'react-icons/bs'
import {BsDribbble} from 'react-icons/bs'
import {FaBehanceSquare} from 'react-icons/fa'
import { motion } from 'framer-motion'
function HeaderSocial() {
  return (
    <motion.div className="header_social"
    initial={{
      opacity :0
    }}
    animate={{
      opacity:1
    }}
    transition={{ delay: 2, duration: 1,ease:'easeIn' }}>
        <a href="https://www.linkedin.com/in/dhanush-saji/" target='_blank'><BsLinkedin /></a>
        <a href="https://github.com/Dhanush-Saji" target='_blank'><BsGithub /></a>
        <a href="https://dribbble.com/dhanushsaji" target='_blank'><BsDribbble /></a>
        <a href="https://www.behance.net/dhanushsaji" target='_blank'><FaBehanceSquare /></a>
    </motion.div>
  )
}

export default HeaderSocial